/* @flow */

import * as React from 'react';
import moment from 'moment';
import withTimer from 'app/hoc/withTimer';
import t from 'app/utils/translate';

type Props = {
  className?: string,
  countdownFrom?: number,
  lang?: string,
  mobile?: boolean,
  startTime: Date | number,
  subscribe: () => void,
  timestamp: number,
  unsubscribe: () => void,
};

class ScheduledTime extends React.Component<Props> {
  props: Props;

  countdownTimerId: number; // eslint-disable-line react/sort-comp

  static defaultProps = {
    className: undefined,
    countdownFrom: 720, // 12 hours worth of minutes
    lang: 'en',
    mobile: false,
  };

  componentDidMount() {
    this.checkSubscription();
  }

  componentDidUpdate() {
    clearTimeout(this.countdownTimerId);
    this.checkSubscription();
  }

  componentWillUnmount() {
    clearTimeout(this.countdownTimerId);
    this.props.unsubscribe();
  }

  checkSubscription() {
    const { countdownFrom, startTime, subscribe, timestamp, unsubscribe } = this.props;
    const time = moment(startTime);

    if (time.isBefore(timestamp)) {
      unsubscribe();
    } else if (time.diff(timestamp, 'minutes') > countdownFrom) {
      const countdownBegin = time.subtract(countdownFrom, 'minutes');
      const waitTime = countdownBegin.valueOf() - timestamp;

      unsubscribe();
      this.countdownTimerId = setTimeout(subscribe, waitTime);
    } else {
      subscribe();
    }
  }

  render() {
    const { className, countdownFrom, lang, mobile, startTime, timestamp } = this.props;
    const time = moment(startTime);

    if (time.isBefore(timestamp)) {
      return (
        <span className={className}>
          {mobile ? t('Now') : t('Due to start')}
        </span>
      );
    }

    if (time.diff(timestamp, 'minutes') <= countdownFrom) {
      const duration = moment.duration(time.valueOf() - timestamp);
      const startsInLabel = mobile ? 'In *seconds*' : 'Starts in *seconds*';

      return (
        <span className={className}>
          {t(startsInLabel).replace(
            '*seconds*',
            duration.format('hh:mm:ss', { trim: false }),
          )}
        </span>
      );
    }

    if (time.clone().endOf('day').diff(timestamp, 'days') < 7) {
      return (
        <span className={className}>
          {time.locale(lang).format('ddd h:mmA')}
        </span>
      );
    }

    return (
      <span className={className}>
        {time.locale(lang).format('DD MMM h:mmA')}
      </span>
    );
  }
}

export default withTimer(ScheduledTime);
